import React from "react";
import { contextApiActions } from "../_redux/_constants";

const Reducer = (state, action) => {
    switch (action.type) {
        case contextApiActions.UI_CONFIRMATION_TOGGEL:
            return {
                ...state,
                ui_confirmation_details: {
                    ...state.ui_confirmation_details,
                    ...action.payload,
                },
            };

        case contextApiActions.UI_RIGHT_SIDE_PANEL_TOGGEL:
            return {
                ...state,
                ui_right_sidepanel_modal_show: action.payload,
            };
        case "FAV_BOX_TOGGLE":
            return {
                ...state,
                ui_fav_box: action.payload,
            };

        case "LARGE_MODAL":
            return {
                ...state,
                ui_large_modal: {
                    ...state.ui_large_modal,
                    ...action.payload,
                },
            };
            case "SHARE_MODAL":
            return {
                ...state,
                ui_share_box: {
                    ...state.ui_share_box,
                    ...action.payload,
                },
            };
        case "CHANGE_ROLE":
            return {
                ...state,
                change_role: action.payload,
            };
        case "CHAT_BOX_MODAL":
            return {
                ...state,
                ui_chat_box: {
                    ...state.ui_chat_box,
                    ...action.payload,
                },
            };
            case "REWARD_MODAL":
            return {
                ...state,
                ui_reward_modal: {
                    ...state.ui_reward_modal,
                    ...action.payload,
                },
            };
        case "FOOTER_CONTENT_MODAL":
            return {
                ...state,
                ui_footer_modal: {
                    ...state.ui_footer_modal,
                    ...action.payload,
                },
            };

        case "HOME_PERFORMANCE_MODAL":
            return {
                ...state,
                ui_home_performance_modal: {
                    ...state.ui_home_performance_modal,
                    ...action.payload,
                },
            };
        
            case "VOTING_MODAL":
                return {
                    ...state,
                    ui_voting_modal: {
                        ...state.ui_voting_modal,
                        ...action.payload,
                    },
                };

        case contextApiActions.SET_SIGNALR_CONNECTTION:
            return {
                ...state,
                signalRConnaction: action.payload,
            };

        case contextApiActions.SET_REQUESTED_URL:
            return {
                ...state,
                requetedUrl: action.payload,
            };

        default:
            return state;
    }
};

export default Reducer;
